<div class="header-title">
    <div class="flex u-align-items-center u-pa-20">
        <div class="flex flex-align-center">
            <a routerLink="/button" aria-label="back"
                class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
                <span class="u-icon icon-chevron-left"></span>
                <span class="u-btn-text">Back</span>
            </a>
        </div>
        <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
            <h1 class="font-semibold u-ma-0 flex header-title--name">Page Header</h1>
        </div>
    </div>
    <div class="c-header__gradient"></div>
</div>
<div *ngIf="isBrowser">
    <div class="content content--modifier-height">
        <h2>Customized Page Header</h2>
        <div class="content__tools-wrap">
            <div class="content__row">
                <div class="c-input-check-inline">
                    <input id="hasLink" class="c-input-check-inline__input" type="checkbox" name="hasLink"
                        [(ngModel)]="hasLink">
                    <label for="hasLink" class="c-input-check-inline__label">Has link</label>
                </div>
                <div class="c-input-check-inline">
                    <input id="hasMetaData" class="c-input-check-inline__input" type="checkbox" name="hasMetaData"
                        [(ngModel)]="hasMetaData">
                    <label for="hasMetaData" class="c-input-check-inline__label">Has Meta Data</label>
                </div>
                <div class="c-input-check-inline">
                    <input id="hasActions" class="c-input-check-inline__input" type="checkbox" name="hasActions"
                        [(ngModel)]="hasActions">
                    <label for="hasActions" class="c-input-check-inline__label">Has Actions</label>
                </div>
                <div class="c-input-check-inline">
                    <input id="hasTabs" class="c-input-check-inline__input" type="checkbox" name="hasTabs"
                        [(ngModel)]="hasTabs">
                    <label for="hasTabs" class="c-input-check-inline__label">Has Tabs</label>
                </div>
                <div class="c-input-check-inline">
                    <input id="hasDropdowns" class="c-input-check-inline__input" type="checkbox" name="hasDropdowns"
                        [(ngModel)]="hasDropdowns">
                    <label for="hasDropdowns" class="c-input-check-inline__label">Has Dropdowns</label>
                </div>
                <div class="c-input-check-inline" *ngIf="hasActions">
                    <input id="hasActionDropdown" class="c-input-check-inline__input" type="checkbox"
                        name="hasActionDropdown" [(ngModel)]="hasActionDropdown">
                    <label for="hasActionDropdown" class="c-input-check-inline__label">Has Action Dropdown</label>
                </div>
            </div>
            <div class="content__row">
                <input id="title" class="c-input-group__control" placeholder="Title" type="text" name="title"
                    [(ngModel)]="title">
                <label for="title" class="u-display-none">Title</label>
                <input id="subTitle" class="c-input-group__control" placeholder="Sub Title" type="text" name="subTitle"
                    [(ngModel)]="subTitle">
                <label for="subTitle" class="u-display-none">Sub Title</label>
            </div>
        </div>
    </div>
    <maced-page-header pageHeaderId="pageHeaderId" [title]="title" [subTitle]="subTitle" [hasLink]="hasLink"
        [hasMetaData]="hasMetaData" [hasActions]="hasActions" [hasDropdowns]="hasDropdowns" [hasTabs]="hasTabs">
        <ng-container ngProjectAs="[pageHeaderlinkData]">
            <maced-link id="linkId1" [links]="link1" [showBackIconClass]="true" [nextIconClass]="nextIconClass"
                [activeClass]="true"  [linkSize]="'extraSmall'"></maced-link>
        </ng-container>
        <ng-container ngProjectAs="[actions]">
            <ul class="c-page-header__button-list">
                <li class="c-page-header__button-list-item" *ngIf="hasActionDropdown">
                    <maced-dropdown dropdownId="dropdownId" name="dropdownId" ariaLabel="Dropdown" label="Query"
                        cheveronClass="icon-chevron-down" [hasCheckboxesDropdown]="false" [options]="options"
                        [selectedOption]="selectedOptions" dropdownLabelId="dropdownLabelId8">
                    </maced-dropdown>
                </li>
                <li class="c-page-header__button-list-item">
                    <maced-button size="large" type="link" color="primary" [url]="callToAction" buttonId="submit2"
                        label="Call to Action" icon="icon-user-circle" position="left"></maced-button>
                </li>
            </ul>

        </ng-container>
        <ng-container ngProjectAs="[pageHeaderMetaData]">
            <ul class="c-page-header__list" role="list">
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
            </ul>
        </ng-container>
        <ng-container ngProjectAs="[pageHeaderTabs]">
            <maced-tab *ngIf="hasTabs" [tabItems]="tabItems" id="TabsContainer1" [currentTab]="activeTab" [ariaLabels]="ariaLabels"
                [padding]="padding" color="gray" [hasSwipe]="true">
                <maced-tabcontent [active]="tab.isActive" [data]="tab" *ngFor="let tab of tabItems">
                    <p>{{tab.tabContentData}}</p>
                </maced-tabcontent>
            </maced-tab>
        </ng-container>
        <ng-container ngProjectAs="[pageHeaderDropdowns]">
            <p class="c-page-header__dropdown-title">Please select the progress data you want to see:</p>
            <ul class="c-page-header__dropdown-list">
                <li class="c-page-header__dropdown-list-item">
                    <maced-dropdown dropdownId="dropdownId1" outerLabel="Label" name="dropdownId1" ariaLabel="Dropdown"
                        label="Unit1 Communication" cheveronClass="icon-chevron-down" [options]="options1"
                        [selectedOption]="selectedOptions1" dropdownLabelId="dropdownLabelId1"></maced-dropdown>
                </li>
                <li class="c-page-header__dropdown-list-item">
                    <maced-dropdown dropdownId="dropdownId2" outerLabel="Label" name="dropdownId2" ariaLabel="Dropdown" label="Lessons"
                        cheveronClass="icon-chevron-down" [options]="options2" [selectedOption]="selectedOptions2"
                        dropdownLabelId="dropdownLabelId2"></maced-dropdown>
                </li>
                <li class="c-page-header__dropdown-list-item">
                    <maced-dropdown dropdownId="dropdownId3" outerLabel="Label" [disabled]="true" name="dropdownId3" ariaLabel="Dropdown"
                        label="Activities" cheveronClass="icon-chevron-down" [options]="options3"
                        [selectedOption]="selectedOptions3" dropdownLabelId="dropdownLabelId3"></maced-dropdown>
                </li>
            </ul>
        </ng-container>
    </maced-page-header>
</div>
<div *ngIf="!isBrowser">
    <maced-page-header pageHeaderId="pageHeaderId" [title]="title" [subTitle]="subTitle" [hasLink]="true"
        [hasMetaData]="true" [hasActions]="true" [hasDropdowns]="true" [hasTabs]="true">
        <ng-container ngProjectAs="[pageHeaderlinkData]">
            <maced-link id="linkId1" [links]="link1" [showBackIconClass]="true" [nextIconClass]="nextIconClass"
                [activeClass]="true"></maced-link>
        </ng-container>
        <ng-container ngProjectAs="[actions]">
            <ul class="c-page-header__button-list">
                <li class="c-page-header__button-list-item" *ngIf="hasActionDropdown">
                    <maced-dropdown dropdownId="dropdownId" name="dropdownId" ariaLabel="Dropdown" label="Query"
                        cheveronClass="icon-chevron-down" [hasCheckboxesDropdown]="false" [options]="options"
                        [selectedOption]="selectedOptions" dropdownLabelId="dropdownLabelId4">
                    </maced-dropdown>
                </li>
                <li class="c-page-header__button-list-item">
                    <maced-button size="large" type="link" color="primary" [url]="callToAction" buttonId="submit2"
                        label="Call to Action" icon="icon-user-circle" position="left"></maced-button>
                </li>
            </ul>

        </ng-container>
        <ng-container ngProjectAs="[pageHeaderMetaData]">
            <ul class="c-page-header__list" role="list">
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
                <li class="c-page-header__list-item" role="listitem">
                    <label class="c-page-header__list-item-label">Label:</label>
                    <span>item info</span>
                </li>
            </ul>
        </ng-container>
        <ng-container ngProjectAs="[pageHeaderTabs]">
            <maced-tab [tabItems]="tabItems" id="TabsContainer1" [currentTab]="activeTab" [ariaLabels]="ariaLabels"
                [padding]="padding" color="gray" [hasSwipe]="true">
                <maced-tabcontent [active]="tab.isActive" [data]="tab" *ngFor="let tab of tabItems">
                    <p>{{tab.tabContentData}}</p>
                </maced-tabcontent>
            </maced-tab>
        </ng-container>
        <ng-container ngProjectAs="[pageHeaderDropdowns]">
            <p>Please select the progress data you want to see:</p>
            <ul class="c-page-header__dropdown-list">
                <li class="c-page-header__dropdown-list-item">
                    <maced-dropdown dropdownId="dropdownId1" name="dropdownId1" ariaLabel="Dropdown"
                        label="Unit1 Communication" cheveronClass="icon-chevron-down" [options]="options1"
                        [selectedOption]="selectedOptions1" dropdownLabelId="dropdownLabelId5"></maced-dropdown>
                </li>
                <li class="c-page-header__dropdown-list-item">
                    <maced-dropdown dropdownId="dropdownId2" name="dropdownId2" ariaLabel="Dropdown" label="Lessons"
                        cheveronClass="icon-chevron-down" [options]="options2" [selectedOption]="selectedOptions2"
                        dropdownLabelId="dropdownLabelId6"></maced-dropdown>
                </li>
                <li class="c-page-header__dropdown-list-item">
                    <maced-dropdown dropdownId="dropdownId3" [disabled]="true" name="dropdownId3" ariaLabel="Dropdown"
                        label="Activities" cheveronClass="icon-chevron-down" [options]="options3"
                        [selectedOption]="selectedOptions3" dropdownLabelId="dropdownLabelId7"></maced-dropdown>
                </li>
            </ul>
        </ng-container>
    </maced-page-header>
</div>